export const KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/yieldbird-platform/my-workspace-was-deactivated-what-to-do-now' as const
